<script>
// GraficoInstituicoes.vue
import { Pie } from 'vue-chartjs';

export default {
  extends: Pie,
  props: {
    instituicoes: {
      type: Array,
      required: true
    }
  },
  computed: {
    chartData() {
      const topInstituicoes = [...this.instituicoes]
        .sort((a, b) => b.total_estudantes - a.total_estudantes)
        .slice(0, 10);

      return {
        labels: topInstituicoes.map(i => i.descricao),
        datasets: [{
          backgroundColor: [
            '#6a11cb', '#11998e', '#f46b45', '#2575fc', '#38ef7d',
            '#eea849', '#833ab4', '#fd1d1d', '#fcb045', '#4e54c8'
          ],
          data: topInstituicoes.map(i => i.total_estudantes),
          borderWidth: 0,
          hoverBorderWidth: 2,
          hoverBorderColor: '#fff',
          hoverOffset: 10
        }]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 60,
        legend: { 
          position: 'bottom',
          labels: {
            fontColor: '#34495e',
            fontSize: 12,
            padding: 20,
            usePointStyle: true
          }
        },
        tooltips: {
          backgroundColor: 'rgba(0,0,0,0.8)',
          titleFontSize: 14,
          bodyFontSize: 12,
          xPadding: 12,
          yPadding: 12,
          cornerRadius: 4,
          displayColors: false
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      };
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
  watch: {
    instituicoes() {
      this.renderChart(this.chartData, this.chartOptions);
    }
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}

canvas {
  max-width: 100%;
  height: auto !important;
}
</style>